/* eslint-disable @typescript-eslint/no-unsafe-return */
import type { SearchFilters } from '../schemas'
import { FetchCampsitePriceSearchService } from './FetchCampsitePriceSearchService'
import { FetchCampsiteSearchService } from './FetchCampsiteSearchService'

export class UnifiedCampsiteSearchService {
  private searchService: FetchCampsiteSearchService
  private priceSearchService: FetchCampsitePriceSearchService
  private abortController = new AbortController()

  constructor() {
    const fetchOptions = {
      timeout: 10000,
    }
    this.searchService = new FetchCampsiteSearchService({
      fetchOptions,
    })
    this.priceSearchService = new FetchCampsitePriceSearchService({
      fetchOptions,
    })
  }

  async search(
    langCode: string,
    filters: SearchFilters,
    searchUrl?: string,
    fetchOptions?: any,
  ) {
    if (this.shouldUsePriceSearch(filters)) {
      // we use limit 20 so we hit the cached results
      if (filters.limit === 0) {
        filters = { ...filters, limit: 20 }
      }
      return await this.priceSearchService.search(
        langCode,
        filters,
        undefined,
        { ...fetchOptions, signal: this.abortController.signal },
      )
    }
    return await this.searchService.search(
      langCode,
      filters,
      undefined,
      searchUrl,
      { ...fetchOptions, signal: this.abortController.signal },
    )
  }

  cancel() {
    this.abortController.abort()
    this.abortController = new AbortController()
  }

  private shouldUsePriceSearch(filters: SearchFilters): boolean {
    return Boolean(filters.dates?.arrive && filters.dates?.depart)
  }
}
